/**
 * Tidies a website typed into a form the way the API does: blank is none, a
 * missing scheme gets https://. Returns undefined when it isn't a usable
 * http(s) address, so the form can say so before saving.
 */
export function normalizeWebsite(raw: string): string | null | undefined {
  const site = raw.trim()
  if (site === '') return null
  const withScheme = site.includes('://') ? site : `https://${site}`
  if (withScheme.length > 500 || /\s/.test(withScheme)) return undefined
  try {
    const url = new URL(withScheme)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return undefined
    if (!url.hostname.includes('.') || url.username || url.password) return undefined
    return withScheme
  } catch {
    return undefined
  }
}

/** "https://www.bloodbanner.gg/play" -> "bloodbanner.gg", for link labels. */
export function websiteLabel(href: string): string {
  try {
    return new URL(href).hostname.replace(/^www\./, '')
  } catch {
    return href
  }
}
